// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1_O43","cls2":"FocusedNav-cls2_Dnm FocusedNav-cls1_O43"};